import React from 'react';
import { TranslateScope } from '@pegasus/translation';

export const ForYouView: React.FC = () => {
    // useMylounge(); //TODO: needed?

    return (
        <TranslateScope path="myLounge">
            <div>For you</div>
        </TranslateScope>
    );
};
